import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn--primary bg-primary rounded text-white py-2 font-medium"
}, " Сохранить данные ", -1)

import { reactive, computed, Component } from "vue";
import { useStore } from "vuex";
import AppInput from "../forms/AppInput.vue";
import AppRadio from "../forms/AppRadio.vue";
import AppSelect from "../forms/AppSelect.vue";
import AppTextarea from "../forms/AppTextarea.vue";
import AppFileUpload from "../forms/AppFileUpload.vue";

import { IUserData } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeForm',
  setup(__props) {

const store = useStore();

const userData: IUserData = reactive({
  username: {
    name: "username",
    element: "input",
    text: "Введите ваше имя",
    type: "text",
    value: "",
    required: true,
    validations: ["required"]
  },
  usersurname: {
    name: "usersurname",
    element: "input",
    text: "Введите вашу фамилию",
    type: "text",
    value: "",
    required: false
  },
  userbirth: {
    name: "userbirth",
    element: "input",
    text: "Введите вашу дату рождения",
    type: "date",
    value: "",
    required: false
  },
  useremail: {
    name: "email",
    element: "input",
    text: "Введите вашу электронную почту",
    type: "email",
    value: "",
    required: false,
    validations: ["email"]
  },
  userseason: {
    name: "season",
    element: "select",
    text: "Выберете ваше любимое время года",
    value: "",
    required: false,
    options: [
      { key: "winter", name: "Зима" },
      { key: "spring", name: "Весна" },
      { key: "summer", name: "Лето" },
      { key: "autumn", name: "Осень" }
    ]
  },
  userphoto: {
    name: "image",
    element: "file",
    text: "Загрузите ваш аватар",
    file: {
      types: "image/png, image/jpeg",
      filesAmount: 1
    },
    value: "",
    required: false
  },
  userdesc: {
    name: "descripttion",
    element: "textarea",
    text: "Расскажите о себе",
    value: "",
    required: false
  },
  usergender: {
    name: "gender",
    element: "radio",
    text: "Укажите ваш пол",
    type: "radio",
    value: "male",
    options: [
      { key: "none", name: "Не указан" },
      { key: "male", name: "Мужской" },
      { key: "female", name: "Женский" }
    ],
    required: false
  }
});

const setData = (value: string | number, name: string | "") => {
  console.log("🚀 ~ file: HomeForm.vue ~ line 134 ~ setData ~ name", name);
  console.log("🚀 ~ file: HomeForm.vue ~ line 134 ~ setData ~ value", value);

  Object.values(userData).map((block) => {
    return block.name === name ? (block.value = value) : block;
  });
};

const choseComponent = (element: string): Component => {
  switch (element) {
    case "input":
      return AppInput;
    case "textarea":
      return AppTextarea;
    case "radio":
      return AppRadio;
    case "select":
      return AppSelect;
    case "file":
      return AppFileUpload;

    default:
      return AppInput;
  }
};

const sendableData = computed(() => {
  let arrEntr = Object.entries(userData).map((item) => {
    return [item[0], item[1].value];
  });

  let parsdObj = arrEntr.reduce((result, item) => {
    let key = item[0];
    result[key] = item[1];
    return result;
  }, {});

  return parsdObj;
});

const testGetter = computed(() => {
  return store.getters.userInfo;
});

const saveUserInfo = (): void => {
  // console.log("🚀 ~ file: HomeForm.vue ~ line 155 ~ toSave ~ Save", toSave);

  store.commit("setUserInfo", sendableData.value);
  store.dispatch("uploadUserInfo");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(saveUserInfo, ["prevent"]),
    class: "mx-auto flex flex-col lg:flex-wrap gap-4 w-full lg:w-3/5"
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userData, (field) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent(choseComponent(field.element)), {
        key: field.name,
        name: field.name,
        type: field.type,
        value: field.value,
        options: field.options,
        validations: field.validations,
        required: field.required,
        file: field.file,
        onDataChange: setData
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(field.text), 1)
        ]),
        _: 2
      }, 1064, ["name", "type", "value", "options", "validations", "required", "file"]))
    }), 128)),
    _hoisted_2
  ], 40, _hoisted_1))
}
}

})